import React from "react";
import Wrapper from "../../Components/Wrapper/wrapper";
import { TeacherDetails } from "../../Components/Teachers/TeacherDetails";
import { useLocation } from "react-router-dom";
import { TeacherNavigationHeader } from "../../Constants/Enums/navigationHeader.enum";
import { TeachersStudents } from "../../Components/Teachers/TeachersStudents";

export const TeacherDetailsPage = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const section = searchParams.get("section");
  const teacherId = searchParams.get("teacherId") || "";
  const parsedTeacherId = parseInt(teacherId, 10);

  return (
    <Wrapper
      header={"Teacher details"}
      headerNavigation={[
        {
          text: "Teacher info",
          section: TeacherNavigationHeader.TEACHER_INFO,
        },
        {
          text: "Students",
          section: TeacherNavigationHeader.STUDENTS,
        },
      ]}
    >
      {section === TeacherNavigationHeader.TEACHER_INFO ? (
        <TeacherDetails teacherId={parsedTeacherId} />
      ) : section === TeacherNavigationHeader.STUDENTS ? (
        <TeachersStudents />
      ) : (
        <></>
      )}
    </Wrapper>
  );
};
